import { ObservableQuery } from '@apollo/client';

const OFFERS_QUERY_NAME = 'offers';

/**
 * Builds an Apollo `onQueryUpdated` predicate that narrows a mutation's refetch to the
 * single `offers` query watching `offerId`.
 *
 * `offers` is a shared operation — the home lists and the offers catalog watch it under
 * their own variables — so `refetchQueries: ['offers']` alone would refetch all of them.
 * `useOffer` identifies a single offer via the `idEquals` variable, which is what we match on.
 *
 * Every other query Apollo hands us (`currentCustomer`, plus anything whose cache data the
 * mutation touched) keeps its default behaviour.
 */
export const createRefetchOfferPredicate =
  (offerId: string) =>
  (observableQuery: ObservableQuery<unknown>): boolean =>
    observableQuery.queryName !== OFFERS_QUERY_NAME || observableQuery.variables?.idEquals === offerId;
